import { SortDirection } from '../../../enums/sortDirection'
import { AttachmentsSortProperty } from '../enums/attachmentsSortProperty'

export const getSortFilterId = (sortBy: AttachmentsSortProperty, direction: SortDirection) => `${sortBy}-${direction}`
